import dlv from 'dlv';
import { getCardWidget } from './collection';
import { fetchSCS } from '@cube/utils/lib/scs-api';
import isAllowed from '@cube/restrictions';

export function fetchSlides(feed, site, apiOrigin, maxSlideCount, props) {
	return fetchSCS(`/dccs/id/${feed}/`, site, apiOrigin)
		.then(data => filterSlides(data.slides))
		.then(slides => restrictSlides(slides, props))
		.then(slides => limitMaxSlides(slides, maxSlideCount));
}

// Filter slides that don't meet all of our requirements
export function filterSlides(slides, maxSlideCount) {
	return slides.reduce( (acc, slide) => {
		let cardType = getCardWidget(slide);
		// If no mapping then drop the slide to enforce all slide types having a canRender function
		if (!cardType || !cardType.canRender) {
			return acc;
		}

		// If we can't render then drop the slide
		if (!cardType.canRender(slide)) {
			return acc;
		}

		// No restriction so keep the slide for rendering
		acc.push(slide);
		return acc;
	}, []);
}

// Remove slides that have restrictions that do not pass
export function restrictSlides(slides, props) {
	let allowed = [];
	for (let i = 0; i < slides.length; i++) {
		if (slides[i].restriction_uri) {
			allowed[i] = isAllowed(slides[i].restriction_uri, props);
		}
		else {
			allowed[i] = true;
		}
	}

	return Promise.all(allowed)
		.then((res) => (
			slides.reduce( (acc, slide, i) => {
				if (res[i]) {
					acc.push(slide);
				}
				return acc;
			}, [])
		));
}

// Remove any slides beyond the max slide count we allow
export function limitMaxSlides(slides, maxSlideCount) {
	if (slides.length > maxSlideCount) {
		return slides.slice(0, maxSlideCount );
	}

	return slides;
}

const MIN_WIDTH=320;

export function getImage(slide, cardSize) {
	let match = dlv(slide.assets[0].images.filter((image) => image.role === cardSize), '0');

	// found cardSize and it has ok width
	if (dlv(match, 'width') >= MIN_WIDTH) {
		return match.src;
	}

	// if was looking for small and wasn't big enough, look for medium image
	if (cardSize.indexOf('small-') === 0) {
		let newCardSize = cardSize.replace('small-', 'medium-');
		let largeOption = dlv(slide.assets[0].images.filter((image) => image.role === newCardSize), '0');
		if (largeOption) return largeOption.src;
	}

	// If we have a match, use it even if it is small
	if (match) return match.src;

	// Default to returning the first image if could not get a match
	return dlv(slide, 'assets.0.images.0.src');
}

export function loadBgImage(url, onLoadEvent) {
	let img = new Image();
	img.onload = function() {
		onLoadEvent();
	};
	img.src = url;
	img = null;
}
